import React from 'react';
import { ThemeString } from '../../types/Theme';
import { OpenModal } from '../../types/PaymentMethodsBannerProps';
import { DeviceTypeString } from '../../types/DeviceType';
import { CurrencyString } from '../../types/Currency';
import { CountryString } from '../../types/Country';
import { PaymentMethodItem } from './elements';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { BuyNowPayLaterMethod } from '@wix/cashier-core/dist/src/services/PaymentMethod/types';

export interface PaymentMethodsListProps {
  paymentMethods: PaymentMethod[];
  bnplMethods?: BuyNowPayLaterMethod[];
  amount: string;
  currency: CurrencyString;
  deviceType: DeviceTypeString;
  theme: ThemeString;
  publicBaseUrl: string;
  locale: string;
  country: CountryString;
  openModal: OpenModal;
}

export const PaymentMethodsListView: React.FC<PaymentMethodsListProps> = ({
  paymentMethods,
  bnplMethods,
  amount,
  currency,
  deviceType,
  theme,
  publicBaseUrl,
  openModal,
  locale,
  country,
}) => (
  <>
    {paymentMethods.map((paymentMethod) => (
      <PaymentMethodItem
        paymentMethod={paymentMethod}
        bnplPayload={bnplMethods.find((m) => m.paymentMethod === paymentMethod)}
        amount={amount}
        currency={currency}
        deviceType={deviceType}
        theme={theme}
        publicBaseUrl={publicBaseUrl}
        openModal={openModal}
        locale={locale}
        country={country}
        key={paymentMethod}
      />
    ))}
  </>
);
PaymentMethodsListView.displayName = 'PaymentMethodsListView';
